import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-vendor-detail',
    templateUrl: './breadcrumb.vendor.detail.component.html'
})

export class BreadcrumbVendorDetailComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
